export { default as GDMInputLabel } from './GDMInputLabel';

export type { GDMInputLabelComponent, GDMInputLabelProps } from './GDMInputLabel.type';
